export function contentKind(item) {
  if (item.contentKind) return item.contentKind;
  if (item.type !== "resource") return "videos";
  return item.attachments?.some(file => file.mime?.startsWith("image/")) ? "photos" : "documents";
}
export function contentDuration(item) {
  const seconds = Number(item.hls?.duration || item.video?.duration || item.duration);
  if (!Number.isFinite(seconds) || seconds <= 0) return item.type === "live" ? "Live class" : "Duration pending";
  const total = Math.floor(seconds), hours = Math.floor(total / 3600);
  return (hours ? hours + ":" : "") + (hours ? String(Math.floor(total / 60) % 60).padStart(2, "0") : Math.floor(total / 60)) + ":" + String(total % 60).padStart(2, "0");
}

export function postedAgo(date, now = Date.now()) {
 const seconds = Math.max(0, Math.floor((now - Date.parse(date)) / 1000));
 if (!Number.isFinite(seconds)) return "";
 if (seconds < 60) return "Just now";
 for (const [unit, size] of [["year",31536000],["month",2592000],["day",86400],["hour",3600],["minute",60]]) {
   if (seconds >= size) { const count = Math.floor(seconds / size); return count + " " + unit + (count === 1 ? "" : "s") + " ago"; }
 }
}
